import React from 'react';
import {AutocompleteArrayInput, Create, ReferenceArrayInput, ReferenceInput, required, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid, TreeCheckboxInput} from '../../components'
import {TreeCheckboxInputV2} from "../../components/TreeCheckboxInputV2";

export const ExemptionCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <React.Fragment>
                <Grid item xs={12} sm={6}>
                    <ReferenceArrayInput source="customerIds" reference="customers"
                                         filter={{studentOnly: true}}
                                         sort={{field: 'name', order: 'ASC'}}
                                         perPage={30}
                                         validate={required()} {...props} >
                        <AutocompleteArrayInput optionText="displayName"/>
                    </ReferenceArrayInput>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <label>Danh sách miễn giảm *</label>
                    <div style={{maxHeight: '300px', overflow: 'auto'}}>
                        <ReferenceInput source="exemptionPolicyIds"
                                        reference="exemptionPolicies"
                                        perPage={999}
                                        {...props} >
                            <TreeCheckboxInput optionValue="id"
                                               expandTopLevel={true}/>
                        </ReferenceInput>
                    </div>
                </Grid>
                    </React.Fragment>
            </Grid>
        </SimpleForm>
    </Create>
);

export default ExemptionCreate
